import { FundHypotheticalProtectedClawbackInfo } from "gen/model/fundHypotheticalProtectedClawbackInfo";
import { decimalOrZero } from "shared/utils/DecimalUtils";

export const isInfoPotentialClawback = (
  info: FundHypotheticalProtectedClawbackInfo,
): boolean =>
  decimalOrZero(info.amount_subject_to_clawback).gt(decimalOrZero(null));
